import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

// value: ISO "YYYY-MM-DD" or ""; onChange(iso)
function isoToDisplay(iso) {
  if (!iso) return "";
  const p = String(iso).slice(0, 10).split("-");
  if (p.length !== 3) return "";
  return `${p[2]}-${p[1]}-${p[0]}`;
}

function displayToIso(text) {
  const m = String(text).trim().match(/^(\d{1,2})[-./](\d{1,2})[-./](\d{4})$/);
  if (!m) return null;
  const dd = parseInt(m[1], 10);
  const mm = parseInt(m[2], 10);
  const yy = parseInt(m[3], 10);
  if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return null;
  const dt = new Date(yy, mm - 1, dd);
  if (dt.getFullYear() !== yy || dt.getMonth() !== mm - 1 || dt.getDate() !== dd) return null;
  return `${yy.toString().padStart(4, "0")}-${mm.toString().padStart(2, "0")}-${dd.toString().padStart(2, "0")}`;
}

export function DateInput({ value, onChange, className, ...props }) {
  const [text, setText] = useState(isoToDisplay(value));
  useEffect(() => {
    setText(isoToDisplay(value));
  }, [value]);
  const handle = (e) => {
    const t = e.target.value;
    setText(t);
    if (t === "") {
      onChange("");
      return;
    }
    const iso = displayToIso(t);
    if (iso !== null) onChange(iso);
  };
  return <Input value={text} onChange={handle} placeholder="ZZ-LL-AAAA" inputMode="numeric" className={className} {...props} />;
}

// value: "YYYY-MM" or ""; onChange(ym)
function ymToDisplay(ym) {
  if (!ym) return "";
  const p = String(ym).split("-");
  if (p.length < 2) return "";
  return `${p[1]}-${p[0]}`;
}
function displayToYm(text) {
  const m = String(text).trim().match(/^(\d{1,2})[-./](\d{4})$/);
  if (!m) return null;
  const mm = parseInt(m[1], 10);
  const yy = parseInt(m[2], 10);
  if (mm < 1 || mm > 12) return null;
  return `${yy.toString().padStart(4, "0")}-${mm.toString().padStart(2, "0")}`;
}

export function MonthInput({ value, onChange, className, ...props }) {
  const [text, setText] = useState(ymToDisplay(value));
  useEffect(() => {
    setText(ymToDisplay(value));
  }, [value]);
  const handle = (e) => {
    const t = e.target.value;
    setText(t);
    if (t === "") {
      onChange("");
      return;
    }
    const ym = displayToYm(t);
    if (ym !== null) onChange(ym);
  };
  return <Input value={text} onChange={handle} placeholder="LL-AAAA" inputMode="numeric" className={className} {...props} />;
}
